import React from 'react';

export default function OneOmicsLogo({
  height = 40,
  maxWidth = '190px',
  dark = false,
  collapsed = false,
  style = {},
  className = '',
  href = 'https://www.oneomics.in',
  target = '_blank',
  rel = 'noopener noreferrer',
  onClick
}) {
  if (collapsed) {
    return (
      <div
        title="ONEOMICS"
        onClick={onClick}
        style={{
          display: 'inline-flex',
          flexDirection: 'column',
          justifyContent: 'center',
          gap: '5px',
          width: '30px',
          height: typeof height === 'number' ? `${height}px` : height,
          cursor: onClick ? 'pointer' : 'default',
          flexShrink: 0,
          ...style,
        }}
        className={className}
      >
        <div style={{ height: '6px', background: '#ED0C0D', borderRadius: '999px', width: '100%' }} />
        <div style={{ height: '6px', background: '#0C90EE', borderRadius: '999px', width: '100%' }} />
        <div style={{ height: '6px', background: '#36A118', borderRadius: '999px', width: '100%' }} />
      </div>
    );
  }

  const imgElement = (
    <img
      src="/logo.png"
      alt="OneOmics QC Suite"
      onClick={onClick}
      style={{
        height: typeof height === 'number' ? `${height}px` : height,
        maxWidth: typeof maxWidth === 'number' ? `${maxWidth}px` : maxWidth,
        objectFit: 'contain',
        objectPosition: 'left center',
        filter: dark ? 'invert(1)' : 'none',
        cursor: (onClick || href) ? 'pointer' : 'default',
        ...style,
      }}
      className={className}
    />
  );

  if (href && !onClick) {
    return (
      <a
        href={href}
        target={target}
        rel={rel}
        style={{
          display: 'inline-flex',
          alignItems: 'center',
          textDecoration: 'none',
          cursor: 'pointer',
        }}
      >
        {imgElement}
      </a>
    );
  }

  return imgElement;
}
